import React from 'react'
import Chart from "react-apexcharts";

export default function TimeSpending(props) {

    const { graph } = props
    // console.log("graph", graph)

    const days = graph && graph.map(val => val.start_date)
    const time = graph && graph.map(val => val.total_timer)

    var series = [{
        name: 'Time',
        data: time ? time : [],
    }]

    var options = {
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            toolbar: {
                show: false
            },
            zoom: {
                enabled: true
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        plotOptions: {
            bar: {
                horizontal: false,
                borderRadius: 10,
                dataLabels: {
                    total: {
                        enabled: true,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        xaxis: {
            type: 'day',
            categories: days ? days : [],
        },
        legend: {
            position: 'top',
            offsetY: 40
        },
        fill: {
            opacity: 1
        }
    }

    return (
        <>
            <div>
                <div className='dash_head'>
                    <h5>Time Spending</h5>
                </div>

                <Chart options={options} series={series} type="bar" height='auto' width='100%' />
            </div>
        </>
    )
}
